/**
 * filename：zh.js
 */
export const h = {
  title1: '个人赛考量申请列表',
  back1: '返回首页',
  contentStr1: '申请考量信息',
  contentStr2: '个人赛考量信息',
  contentStr3: '(注*因涉及到试卷数量申请，请仔细填写申请信息，谢谢!)',
  contentStr4: '当前赛季活动',
  contentStr5: '预计考试时间',
  contentStr6: '学校省市区',
  contentStr7: '学校名称',
  contentStr8: '参赛包含年级',
  contentStr9: '每年级班级数',
  contentStr10: '预计考量',
  contentStr11: '备注(非必填)',
  contentStr12: '请填写备注信息',
  contentStr13: '邮寄信息',
  contentStr14: '注*因涉及到比赛资料邮寄，请仔细填写邮寄信息，谢谢！',
  contentStr15: '收件人姓名',
  contentStr16: '收件人联系方式',
  contentStr17: '邮箱',
  contentStr18: '收货地址',
  contentStr19: '详细地址',
  contentStr20: '注*因涉及到物料准备，请务必认真填写，一旦提交无法修改本次申请，如需修改，请联系赛区组委会老师！',
  contentStr21: '赛区组委会老师！',
  contentStr22: '提交考量信息',
  contentStr23: '申请成功，请等待组委会和您联系',
  contentStr24: '提交成功，请您耐心等待组委会审核！',
  contentStr25: '团体赛参赛申请',
  contentStr26: '提交信息',
  contentStr27: '资格审核',
  contentStr28: '报名缴费',
  contentStr29: '俱乐部组别',
  contentStr30: '指导教师姓名',
  contentStr31: '指导教师联系方式',
  contentStr32: '拟参赛队伍数量',
  contentStr33: '俱乐部名称',
  contentStr34: '1、ITSO x 团体赛战队年度注册费用:480元/队/赛季;',
  contentStr35: '2、每所学校同一组别最多可报名2支队伍;',
  contentStr36: '3、注册队伍提交注册信息后,经组委会审核确认后,方可完成注册;',
  contentStr37: '4、注册费用涵盖：2026-27赛季ITSOx团体赛全国总决选参赛资格，参赛代码证书，官方统一培训，2026-27赛季官方词库手册2本、线上词库大礼包1个；',
  contentStr38: '5、如注册队伍缴纳年度注册费用后,因学校或学生个人原因无法参与本年度后续比赛活动,年度注册费用不支持退费,但注册队伍仍然享有以上权益;',
  contentStr39: '6、队伍注册成功后,将会获得带有组委会唯一识别编码资格证书,该证书本年度有效,并可在SPBCN官方网站进行查询验证;',
  contentStr40: '资料审核中',
  contentStr41: '缴费状态',
  contentStr42: '未缴费',
  contentStr43: '参赛资格证书已生成，点击查看',
  contentStr44: '审核失败',
  contentStr45: '序号',
  contentStr46: '暂无考量申请数据',
  contentStr47: '总考量',
  contentStr48: '预计考试时间',
  contentStr49: '查看详情',
  contentStr50: '操作',
  contentStr51: '请选择',
  contentStr52: '请输入',
  contentStr53: '请输入邮箱（用于发送考试使用音频等文件）',
  contentStr54: '例：镇（街道），xx小区x号楼x单元门牌号',
  contentStr55: '等待组委会邮寄试卷',
  contentStr56: '等待接收试卷',
  contentStr57: '再逛逛',
  contentStr58: '审核通过',
  contentStr59: '已退款',
  contentStr60: '重新提交报名信息',
  contentStr61: '已缴费',
  contentStr62: '参赛证书',
  contentStr63: '下 载',
  contentStr64: '关 闭',
  contentStr65: '未通过原因是:',
  contentStr66: '班',
  contentStr67: '学校登录',
  contentStr68: '请输入手机号',
  contentStr69: '返回首页',
  contentStr70: '手机号',
  contentStr71: '请输入手机号',
  contentStr72: '验证码',
  contentStr73: '请输入验证码',
  contentStr74: '登录',
  contentStr75: '请输入正确手机号',
  contentStr76: '短信发送成功，请注意查收',
  contentStr77: '登录成功！',
  contentStr78: '发送验证码',
  contentStr79: '负责老师',
  contentStr80: '注 册',
  contentStr81: '暂未开放，敬请期待!',
  contentStr82: '恭喜您，注册成功！',
  contentStr83: '提示',
  contentStr84: '确定',
  contentStr85: '取消',
  studyPlan1: '竞技计划',
  studyPlanNoData: '暂未创建竞技计划',
  studyPlanCreate: '创建',
  studyPlanCancel: '取 消',
  studyPlanSubmit: '提 交',
  formItem1: '计划名称',
  formItem2: '计划类型',
  formItem3: '一级属性',
  formItem4: '二级属性',
  formItem5: '起止时间',
  formTypeWeek: '周计划',
  formTypeMonth: '月计划',
  formTypeSemester: '学期计划',
  formTypeYear: '学年计划',
  rsp: '至',
  sp: '开始日期',
  ep: '结束日期',
  np: '请输入计划名称',
  tp: '请选择计划类型',
  rtp: '请选择起止时间',
  oneLevelAP: '例：年级',
  oneLevelBP: '例：一年级',
  twoLevelAP: '例：班级',
  twoLevelBP: '例：1',
  createTime: '创建时间',
  creator: '创建者',
  state: '状态',
  edit: '修改',
  toWord: '查看单词列表',
  studyPlan2: '学习计划单词列表',
  wordListNoData: '暂无单词数据',
  importWords: '批量导入单词',
  importWordsWithScan: '扫读笔导入单词',
  downLoadTemplate: '下载模版',
  uploadExcel: '确认上传',
  chooseExcel: '选取文件',
  wordListTip1: '1、下载Excel模版',
  wordListTip2: '2、按模版要求修改文件',
  wordListTip3: '3、点击下方按钮选取文件',
  wordListTip4: '4、确认无误后，点击确认上传',
  spell: '单词',
  taskType: '教学任务',
  source: '来源',
  difficulty: '难度',
  del: '删除',
  delAsk: '确认删除该单词?',
  spellP: '请输入单词',
  hadDel: '已删除',
  stuP: '请输入姓名',
  phoneP: '请输入手机号',
  importStudent: '批量导入学生名单',
  import: '批量导入',
  studentNoData: '暂无学生数据',
  addbtn: '添加学生',
  stuName: '学生姓名',
  search: '查询',
  reset: '重置',
  chooseFileFirst: '请先选择要上传的文件',
  uploadSucc: '批量上传成功',
  failReason: '请修改后再上传，失败原因:',
  failUpload: '上传失败',
  addSucc: '添加成功',
  comfirmToAdd: '确认添加',
  state1: '正常',
  state2: '禁用',
  delAsk2: '确认删除该学生？',
  base: '达标',
  increase: '提高',
  extra: '思考',
  planManagement: '计划管理',
  studentManagement: '学生管理',
  scanNotes1: '1，需要使用同手机号的微信进行授权登录扫读笔蜂道具\n2，在网站勾选需要上传单词的计划列表左侧勾选框，点击底部开始上传按钮\n3，点击扫读笔扫描结果的单词即可上传该单词到计划内\n4，上传结束后点击结束上传按钮结束本次上传。',
  moreOperation: '更多操作',
  beginUpLoad: '开始上传',
  endUpLoad: '结束上传',
  upLoadEndTips: '是否确认结束当前上传任务？',
  upLoadEndTips2: '*请您在扫读笔上进行扫描，并选择上传单词操作，上传结束后请点击结束上传按钮，请勿刷新该界面',
  reloading: '加载中',
  clickedReloading: '点击刷新',
  competitionPlan: '竞技计划'
}
